import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getWhatsAppUrl, TRAINERS } from "../config/contact";
import logo from "../images/logoTheCrew.svg";
import "../blocks/Header.css";

const navigation = [
  ["Método", "metodo"],
  ["Equipo", "equipo"],
  ["El centro", "centro"],
  ["Preguntas", "preguntas"],
];

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setIsOpen(false), [location]);
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [isOpen]);

  const linkFor = (anchor) => (location.pathname === "/" ? `#${anchor}` : `/#${anchor}`);

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link className="site-header__brand" to="/" aria-label="THE CREW, inicio">
          <img src={logo} alt="THE CREW Personal Trainers" />
        </Link>
        <nav className="site-header__desktop" aria-label="Navegación principal">
          {navigation.map(([label, anchor]) => <a key={anchor} href={linkFor(anchor)}>{label}</a>)}
        </nav>
        <a className="site-header__cta" href={getWhatsAppUrl(TRAINERS.juanCarlos)} target="_blank" rel="noreferrer">Cuéntanos tu caso</a>
        <button className={`site-header__menu${isOpen ? " is-open" : ""}`} type="button" aria-expanded={isOpen} aria-controls="mobile-navigation" aria-label={isOpen ? "Cerrar menú" : "Abrir menú"} onClick={() => setIsOpen((open) => !open)}>
          <span /><span />
        </button>
      </div>
      <div id="mobile-navigation" className={`mobile-nav${isOpen ? " is-open" : ""}`}>
        <p>THE CREW · MALLORCA</p>
        <nav aria-label="Navegación móvil">
          {navigation.map(([label, anchor], index) => (
            <a key={anchor} href={linkFor(anchor)} onClick={() => setIsOpen(false)}><span>0{index + 1}</span>{label}</a>
          ))}
        </nav>
        <a className="button button--light mobile-nav__cta" href={getWhatsAppUrl(TRAINERS.juanCarlos)} target="_blank" rel="noreferrer">Cuéntanos tu caso <span aria-hidden="true">↗</span></a>
      </div>
    </header>
  );
}

export default Header;
